import React from "react";
import "./BrowseKitchensSkeleton.css";

const BrowseKitchensSkeleton = () => {
  return (
    <div className="browse-page skeleton-page">
      {/* Navbar Skeleton */}
      <nav className="nav-bar skeleton-navbar">
        <div className="navbar-content">
          <div className="nav-left">
            <div className="skeleton-logo"></div>
          </div>
          <div className="nav-center">
            <div className="skeleton-nav-item"></div>
            <div className="skeleton-nav-item"></div>
          </div>
          <div className="nav-right">
            <div className="skeleton-profile-container">
              <div className="skeleton-auth-button"></div>
              <div className="skeleton-auth-button"></div>
            </div>
          </div>
          <div className="mobile-bottom-nav">
            <div className="skeleton-navbar-toggle"></div>
            <div className="skeleton-navbar-toggle"></div>
            <div className="skeleton-navbar-toggle"></div>
            <div className="skeleton-navbar-toggle"></div>
          </div>
        </div>
      </nav>

      {/* Hero Section Skeleton */}
      <section className="hero-section skeleton-hero">
        <div className="hero-content">
          <div className="skeleton-hero-title"></div>
          <div className="skeleton-hero-subtitle"></div>
          <div className="search-bar">
            <div className="browse-search-bar skeleton-search-bar">
              <div className="autocomplete-container">
                <div className="skeleton-geo-button"></div>
                <div className="skeleton-search-input"></div>
                <div className="skeleton-clear-button"></div>
              </div>
            </div>
            <div className="category-bar-container">
              <div className="category-bar-1 skeleton-category-bar">
                {Array(8)
                  .fill()
                  .map((_, index) => (
                    <div className="skeleton-category-button" key={index}></div>
                  ))}
              </div>
              <div className="action-buttons skeleton-action-buttons">
                <div className="skeleton-filter-button"></div>
              </div>
            </div>
            <div className="floating-map-button">
              <div className="skeleton-map-float-btn"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Sticky Placeholder */}
      <div className="skeleton-sticky-placeholder"></div>

      {/* Kitchen List Skeleton */}
      <section className="kitchen-section">
        <div className="kitchen-list">
          {Array(6)
            .fill()
            .map((_, index) => (
              <div
                className="kitchen-card-container skeleton-kitchen-card"
                key={index}
              >
                <div className="skeleton-card-image"></div>
                <div className="skeleton-favourite-button"></div>
                <div className="skeleton-card-content">
                  <div className="skeleton-card-title"></div>
                  <div className="skeleton-card-subtitle"></div>
                  <div className="skeleton-card-details"></div>
                </div>
              </div>
            ))}
        </div>
      </section>

      {/* Map Section Skeleton */}
      <section className="map-section">
        <div className="map-container skeleton-map">
          <div className="skeleton-loading-container">
            <div className="skeleton-loading-circle"></div>
            <div className="skeleton-loading-text"></div>
          </div>
        </div>
      </section>

      {/* Footer Skeleton */}
      <div className="skeleton-footer">
        <div className="skeleton-footer-content"></div>
      </div>
    </div>
  );
};

export default BrowseKitchensSkeleton;
